import React from 'react';

const SecurityBadges: React.FC = () => {
  return (
    <div className="mt-8 mb-6 fade-in">
      <p 
        className="text-center mb-2"
        style={{
          color: '#666',
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: 1.35,
          WebkitFontSmoothing: 'antialiased',
          wordBreak: 'break-word',
          hyphens: 'initial',
          WebkitTapHighlightColor: 'transparent',
          letterSpacing: 'normal'
        }}
        dangerouslySetInnerHTML={{ __html: '⭐️⭐️⭐️⭐️⭐️ Das Urteil unserer Kunden: <strong>HERVORRAGEND 4.7 von 5 Sternen</strong>' }}
      />
      <p 
        className="text-center mb-4 flex items-center justify-center gap-2"
        style={{
          color: '#666',
          fontSize: '1rem',
          fontWeight: 400,
          lineHeight: 1.35,
          WebkitFontSmoothing: 'antialiased',
          wordBreak: 'break-word',
          hyphens: 'initial',
          WebkitTapHighlightColor: 'transparent',
          letterSpacing: 'normal',
          fontStyle: 'italic'
        }}
      >
        <span className="inline-block w-4 h-4">🔒</span>
        Ihre Daten werden streng vertraulich behandelt und nicht an Dritte weitergegeben.
      </p>
      
      {/* SVG Badges */}
      <div className="flex flex-col items-center my-4">
        {/* New SVG Badges */}
        <div className="flex justify-center items-center gap-6 flex-nowrap">
          {/* SSL Badge */}
          <div className="flex overflow-hidden" style={{ width: '140px', height: '55px', minWidth: '140px' }}>
            <img 
              src="/images/ssl-badge.svg" 
              alt="SSL Sichere Verbindung" 
              className="w-full h-full"
              style={{
                objectFit: 'contain',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
            />
          </div>
          
          {/* DSGVO Badge - Using external SVG file */}
          <div className="flex rounded-lg overflow-hidden" style={{ width: '140px', height: '55px', minWidth: '140px' }}>
            <img 
              src="/images/dsgvo-badge.svg" 
              alt="DSGVO" 
              className="w-full h-full"
              style={{
                objectFit: 'contain',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
            />
          </div>
        </div>
      </div>
      
      <div className="border-t border-gray-200 my-6 max-w-3xl mx-auto"></div>
      
      <div className="flex items-center justify-center gap-3 max-w-xl mx-auto px-4">
        <div className="flex-shrink-0">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 5 3" 
            className="w-8 h-auto"
            style={{ 
              border: '1px solid #eaeaea',
              borderRadius: '4px',
              overflow: 'hidden'
            }}
          >
            <rect width="5" height="3" fill="#000"/>
            <rect width="5" height="2" y="1" fill="#D00"/>
            <rect width="5" height="1" y="2" fill="#FFCE00"/>
          </svg>
        </div>
        <span
          style={{
            color: '#000',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: 1.35,
            WebkitFontSmoothing: 'antialiased',
            wordBreak: 'break-word',
            hyphens: 'initial',
            WebkitTapHighlightColor: 'transparent',
            letterSpacing: 'normal',
            textAlign: 'center'
          }}
        >
          Sie erhalten die zuverlässige Adressauskunft direkt aus den Registern der zuständigen Einwohnermeldeämter.
        </span>
      </div>
    </div>
  );
};

export default SecurityBadges;